module.exports = __webpack_public_path__ + "~@/assets/img/nanoLaw-2.593adc3d.png";